import React, { createContext, useMemo } from 'react';

type Token = {
  token: string;
  expiresOn: Date;
};

const defaultToken = {
  token: '',
  expiresOn: new Date(),
};

export interface AccessTokenContextI {
  accessToken: Token;
  setAccessToken: React.Dispatch<Token>;
  isAccessTokenSet: boolean;
  setIsAccessTokenSet: React.Dispatch<boolean>;
}

export const AccessTokenContext = createContext<
  AccessTokenContextI | undefined
>(undefined);

function AccessToken({ children }: { children: React.ReactChild }) {
  const [accessToken, setAccessToken] = React.useState<Token>(defaultToken);
  const [isAccessTokenSet, setIsAccessTokenSet] = React.useState(false);

  const value = useMemo<AccessTokenContextI>(() => {
    return {
      accessToken,
      setAccessToken,
      isAccessTokenSet,
      setIsAccessTokenSet,
    };
  }, [accessToken, isAccessTokenSet]);

  return (
    <AccessTokenContext.Provider value={value}>
      {children}
    </AccessTokenContext.Provider>
  );
}

function useAccessToken() {
  const context = React.useContext(AccessTokenContext);

  if (context === undefined) {
    throw new Error(
      'useAccessToken must be used within a AccessToken provider'
    );
  }

  return context;
}

export { AccessToken, useAccessToken };
